"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentDetailsLayout = exports.DocumentDetailsLayoutDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_lang_1 = require("../../hooks/use-lang");
var layout_1 = require("../elements/layout");
var document_layout_1 = require("./document-layout");
var list_banner_1 = require("../elements/list-banner");
exports.DocumentDetailsLayoutDefaultProps = {
  loading: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .shp-entity-banner__body {\n      padding-top: 0;\n      padding-bottom: 0;\n    }\n\n  "], ["\n    .shp-entity-banner__body {\n      padding-top: 0;\n      padding-bottom: 0;\n    }\n\n  "])))
});
var ListBannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DocumentCardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DocumentLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", ";\n    border-top: 1px solid ", ";\n  "], ["\n    padding: ", ";\n    border-top: 1px solid ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.COLOR('line-subtle'))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(layout_1.Layout)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ListBanner: (0, styled_components_1.default)(list_banner_1.ListBanner)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ListBannerStyles),
  DocumentLayout: (0, styled_components_1.default)(document_layout_1.DocumentLayout)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DocumentLayoutStyles)
};
var DocumentDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    banner = props.banner;
  var t = (0, use_lang_1.useLang)();
  return React.createElement(My.Container, {
    pad: true,
    className: className
  }, banner, React.createElement(My.DocumentLayout, {
    entity: entity
  }));
};
exports.DocumentDetailsLayout = DocumentDetailsLayout;
exports.DocumentDetailsLayout.defaultProps = exports.DocumentDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;